import * as moment from 'moment';
import { Gender } from '../enums';

export class AddEmployeeInput {
    public firstName: string = '';
    public lastName: string = '';
    public nationalIdentity: string = '';
    public cellphoneNumber: string = '';
    public email: string = '';
    public username: string = '';
    public password: string = '';
    public gender: Gender = Gender.Male;
    public securityLevel: string = '';
    public personalPictureFile: string = '';
    public personalPictureFileName: string = '';
    public departmentId: number = 0;
    public isActive: boolean = false;
    public departmentIds: Array<number> = [];
    public birthDate: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
}
